import type { ApolloCache } from '@apollo/client';

import type { AdTraffickingColumnFragment } from '../../../../../apis/graphql';

type TraffickingAdEdge = {
  __typename: string;
  cursor: string;
  node: AdTraffickingColumnFragment;
};

type TraffickingAdsPage = {
  __typename?: string;
  edges: TraffickingAdEdge[];
  total: number;
};

export const prependCreatedAdsToTraffickingConnections = (
  cache: ApolloCache<object>,
  ads: AdTraffickingColumnFragment[]
): void => {
  if (!ads.length) return;

  cache.modify({
    fields: {
      adsV5(existing: TraffickingAdsPage | undefined) {
        if (!existing?.edges) return existing;

        const newEdges = ads.map((node) => ({
          __typename: 'AdEdgeV5',
          cursor: '',
          node,
        }));

        return {
          ...existing,
          edges: [...newEdges, ...existing.edges],
          total: (existing.total ?? 0) + newEdges.length,
        };
      },
    },
  });
};
